<ng-container *ngrxLet="auction$ as auction">
  {{ auction?.foundation?.currency }}
</ng-container>
